import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";
import { StockReplenishmentRunFilterCategoryModel } from "../../../../../../models/aggregates/erp/stock/stock-replenishment-run-filter-category.model";

@Injectable({ providedIn: "root" })
export class StockReplenishmentRunFilterCategoryService extends BaseApiTemplateService<StockReplenishmentRunFilterCategoryModel> {
  readonly url =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    "erp/stock-replenishment-run-categories/backoffice-ep";

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      "erp/stock-replenishment-run-categories/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      "erp/stock-replenishment-run-categories/backoffice-ep";
    this.httpClient = theHttp;
  }
}
